export default __webpack_public_path__ + "static/media/Joy-Quinney.616405fa.jpg";